import React,{useState,useEffect} from 'react'
import ComanServices from '../../services/ComanServices';
import { SITE_PHONE, SITE_EMAIL } from './siteContact';

function About() {
  const[data, setData] = useState([]);
  useEffect(() => {
    ComanServices.getAbout()
      .then(response => {
        console.log(response.data);
        const data = response.data;
        setData(data);
      })
      .catch(error => {
        console.error("There was an error fetching the about us data!", error);
      });
  }, []);
    const [isOpen, setIsOpen] = useState(false);
    return (

        <section className="about-us-section py-70">
          <div className="container">
            <div className="about-us-inner">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="about-us-img-left">
                    <img src={process.env.REACT_APP_URL + data?.image} alt="Manish Agarwal" />
                  </div>
                </div>
                <div className="col-lg-6 ">
                  <div className="about-us-content-right t">
                    <h4>{data?.Name}</h4>
                    <p className="desc"><strong>QUALIFICATIONS:</strong> {data?.qulafication}</p>
                    <p className="desc"><strong>OCCUPATION:</strong> {data?.occupation} </p>
                    <p className="desc"><strong>EXPERIENCE:</strong>  {data?.experience}</p>
                    <p className="desc"><strong>WEBSITE:</strong>  {data?.website}</p>
                    <p className="desc"><strong>MAIN AREA OF EXPERTISE:</strong>{data?.experties}</p>
                    <p className="desc"><strong>PHONE:</strong> <a href={`tel:+91${SITE_PHONE}`}>+91 {SITE_PHONE}</a></p>
                    <p className="desc"><strong>EMAIL:</strong> <a href={`mailto:${SITE_EMAIL}`}>{SITE_EMAIL}</a></p>
                    <a href="javascript:void(0);" onClick={() => setIsOpen(!isOpen)} className="site-btn btn-red read-more">Read {isOpen ? 'Less' : 'More'}</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="our-story-section about-us-content-right mt-5" style={{display: 'none'}}>
              <h4>WHAT'S OUR STORY</h4>
              <p className="desc">My journey was started while i am studying in 11th standard, many people were talking about stock market because that was the time of harshad mehta's bull run. i heard about stock market and i decided to explore it completly. upto 2012 i completly depended on news from news channels, business news papers etc; but i could not get remarkable success upto that time. in 2012, i heard about technical analysis and its use in stock market. i decided to stop trading and investment completely and starts full focus on learning about charts and their uses in stock market. after learning technical analysis i came to know that chart is supreme. after doing lots of research finally i came to  point that learning technical analysis  is mandatory if you want to become successfull stock market trader or investor.</p>
              <p className="desc">I started learning by buying many courses online and offline. while learning I felt that earning from the stock market is not easy even after doing technical analysis, knowing technical analysis is not enough, and applying technical analysis according to your behaviour in trading and investment is much more important. after long ups and downs and many failures, I finally discovered my winning methods and strategies. and slowly I started to make my methods &amp; strategies more accurate and strong. and now everything going fine and superb.</p>
              <p className="desc">In 2020, I started professionally and founded Hifi Investing. many people want to make money from the stock market but they got failure again and again. some people spend 20 - 30 years of their lives but they still do not make money. So now I decided to start giving guidance to all those people who want to make money in the stock market. except for research and all I have a YouTube channel also named Hifi Investing.</p>
              <p className="desc">By seeing increasing interest in option trading of retail people, I have developed a super tool that will make you more cool and relaxed and it will able to make option chain reading and analysis very easy, identify super and accurate trades and reversals in a very easy way by normal eye keeping. get alerts and web notifications on act point.</p>
            </div>
          </div>
        </section>
      );
}

export default About